import React, { useState } from "react";
import { Link } from "react-router-dom"; // remove if not using react-router
import { FaBars, FaTimes, FaChevronDown } from "react-icons/fa";
import { ICON_MAP, HEADER_LINKS, MegaMenu } from "./MasterHeader";
import Text from "../../core/utils/Text";


const RespNavigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [openMega, setOpenMega] = useState(null);

  return (
    <nav className="w-full bg-cardBgDark shadow-md px-4 py-2 lg:px-8 relative transition-all">
      <div className="h-[2px] w-[90%] absolute left-1/2 -translate-x-1/2 top-0 bg-gradient-to-r from-primaryOrange/0 via-primaryOrange to-primaryOrange/0" />

      {/* Mobile Menu Drawer */}
      <div className="lg:hidden mt-4 space-y-3 transition-all">
        {HEADER_LINKS.map((link) => {
          const { hasMega, megaOptions } = link;

          if (hasMega) {
            const isMegaOpen = openMega === link.tid;
            return (
              <div key={link.tid} className="flex flex-col transition-all">
                <button
                  onClick={() =>
                    setOpenMega(isMegaOpen ? null : link.tid)
                  }
                  className="flex justify-between items-center py-2"
                >
                  <Text tid={link.tid} className="text-base" />
                  <FaChevronDown
                    className={`transition-transform ${isMegaOpen ? "rotate-180" : ""
                      }`}
                  />
                </button>
                {isMegaOpen && (
                  <div className="pl-2 flex flex-col gap-3 items-start">
                    {megaOptions.map((opt) => (
                      <a
                        key={opt.tid}
                        href={opt.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center gap-2 text-sm text-gray-700 dark:text-gray-200"
                      >
                        {ICON_MAP[opt.tid]}
                        <Text tid={opt.tid} />
                      </a>
                    ))}
                  </div>
                )}
              </div>
            );
          }

          return (
            <Link key={link.tid} to={link.href} className="block py-2">
              <Text tid={link.tid} className="text-base" />
            </Link>
          );
        })}
      </div>

      <div className="h-[2px] w-[90%] absolute left-1/2 -translate-x-1/2 bottom-0 bg-gradient-to-r from-primaryOrange/0 via-primaryOrange to-primaryOrange/0" />
    </nav>
  );
};

export default RespNavigation;
